import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tag } from 'src/app/models/tag';

@Component({
  selector: 'app-add-document-tag',
  templateUrl: './add-document-tag.component.html',
  styleUrl: './add-document-tag.component.scss'
})
export class AddDocumentTagComponent {
  tags: Tag[] = [];
  existingTags: Tag[] = [];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddDocumentTagComponent>
  ) {
  }

  ngOnInit(): void {
    if (this.data) {
      this.existingTags = this.data.tags;
    }
  }

  onCancel(): void {
    this.dialogRef.close({
      added: false
    });
  }



  async onAdd() {
    this.dialogRef.close({
      added: true,
      tags: this.tags
    });
  }
}
